<template>
	<el-dialog width="650px" :visible.sync="visible" title="开通支付渠道" :close-on-click-modal="false"
		:close-on-press-escape="false">
    <el-form :model="form" :rules="dataRule" ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()" label-width="120px" class="tax-source-box">
      <el-scrollbar v-if="form.platBodyList.length" class="tax-source-scrollbar">
        <div class="tax-source-list" v-for="(item,index) in form.platBodyList" :key="index">
          <el-form-item label="税源地主体名称:">
            <!-- <el-input :value="item.bodyName" :disabled="true" class="sydIpt"></el-input> -->
			<span class="sydIpt">{{item.bodyName}}</span>
          </el-form-item>
          <el-form-item v-if="item.bankNames && item.bankNames.length" label="支付渠道:" >
            <el-input :value="item.bankNames[0]" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item v-else label="支付渠道:" :prop="'platBodyList['+index+'].payChannel'" :rules="dataRule.payChannel">
            <el-select  v-model="item.payChannel" placeholder="请选择支付渠道" clearable>
              <el-option v-for="(item,ind) in bankList"
                    :key="ind"
                    :value="item.bankName"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-scrollbar>
      <div v-else class="no-data">暂无数据</div>
    </el-form>
		<template slot="footer">
			<el-button v-no-more-click @click="cancel">{{ $t('cancel') }}</el-button>
			<el-button v-no-more-click type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
		</template>
	</el-dialog>
</template>

<script>
	import debounce from 'lodash/debounce'
	import {
		isEmail,
		isMobile
	} from '@/utils/validate'
    import ArrayUtils from "../../../utils/ArrayUtils";
	export default {
		data() {
			return {
				visible: false,
        bankList:[
          { bankName:'招商银行灵账'},
        //   { bankName:'招商银行'},
          // { bankName:'平安银行' },
          { bankName:'支付宝' }
        ],
				dataForm: {
					id: '',
          caId: ''
				},
        form: {
          platBodyList: []
        }
			}
		},
    computed: {
			dataRule() {
				return {
          payChannel: [
            { required: true, message: '请选择支付渠道', trigger: 'change' }
          ],
        }
			}
		},
		methods: {
			init() {
				this.visible = true
				this.$nextTick(() => {
					this.$refs['dataForm'].resetFields()
					this.getPlatBodyList()
				})
			},
//			关闭
			cancel() {
				this.visible = false;
				this.$refs['dataForm'].resetFields();
        this.form.platBodyList = []
			},
			// 获取我方主体列表
			getPlatBodyList() {
				this.$http.get('/sys/plat/info/ca/getBodies', {
						params: {
							caId: this.dataForm.caId
						}
					})
					.then(({
						data: res
					}) => {
						if (res.code !== 0) {
							return this.$message.error(res.msg)
						}
						this.form.platBodyList = res.data
					})
					.catch(() => {})
			},
			// 表单提交
			dataFormSubmitHandle: debounce(function() {
				this.$refs['dataForm'].validate((valid) => {
					if (!valid) {
            //跳转到未选择支付渠道的位置
            this.$nextTick(() => {
              this.$refs.dataForm.$el.querySelectorAll('.is-error')[0].scrollIntoView({ block: 'center', behavior: 'smooth'})
            })
						return false
					}
          let dataList = []
          const { caId, id, childAcctNo } = this.dataForm;
          this.form.platBodyList.map(item => {
            dataList.push({
              bodyId: item.id, 
              bodyName: item.bodyName, 
              caId, 
              bankName: item.payChannel ? item.payChannel : item.bankNames ? item.bankNames[0] : '',
              userId: id,
              childAcctNo
            })
          })
					this.$http.put('/sys/spdb/', dataList).then(({
						data: res
					}) => {
						if (res.code !== 0) {
							return this.$message.error(res.msg)
						}
						this.$message({
							message: '开户成功',
							type: 'success',
							duration: 500,
							onClose: () => {
								this.visible = false
						    this.form.platBodyList = [];
								this.$emit('refreshDataList')
							}
						})
					}).catch(() => {})
				})
			}, 1000, {
				'leading': true,
				'trailing': false
			})
		}
	}
</script>

<style lang="scss" scoped>
	.el-select {
		display: block;
	}

	.mod-sys__user {
		.dept-list {

			.el-input__inner,
			.el-input__suffix {
				cursor: pointer;
			}
		}

		.role-list {
			.el-select {
				width: 100%;
			}
		}
	}
  .tax-source-box{
    max-height: 310px;
    padding: 0 20px;
    .tax-source-scrollbar{
	padding-bottom:30px;
      height: 100%;
      /deep/ .el-scrollbar__wrap{
				overflow-y: scroll;
				max-height: 310px;
				overflow-x:hidden;
			}
    //   .tax-source-list{
        // padding: 22px 16px 0 0;
        // border-bottom: 1px solid #ccc;
        // /deep/ .el-input.is-disabled .el-input__inner{
        //   background: none; 
        //   border: none;
        //   color: #606266;
        //   cursor: auto;
        // }
    //   }
    //   .tax-source-list:last-child{
    //     border-bottom: none;
    //   }
    }
    .no-data{
      text-align: center;
      line-height: 210px;
    }
  }
  .tax-source-list{
	padding:20px 30px;
	background-color:#F3F5FA;
	margin-bottom:20px;
	border-radius:10px;
	.sydIpt{
		border:none;
		background:none;
		font-size:14px;
		color:#262628;
	}
	.el-form-item{
		margin-bottom:5px !important;
	}
  }
</style>
